export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.288 13.763a.75.75 0 01.182-.293l8-8a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-8 8a.749.749 0 01-.293.181l-5.526 1.842a1 1 0 01-1.265-1.265l1.842-5.525zm1.04 1.625l2.283 2.284-3.425 1.142 1.142-3.426zM10 16.94L16.94 10 14 7.06 7.06 14 10 16.94z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.263 3.677a1.75 1.75 0 012.474 0l2.586 2.586a1.75 1.75 0 010 2.474L18.53 10.53a.75.75 0 01-1.06 0l-4-4a.75.75 0 010-1.06l1.793-1.793zm1.414 1.06a.25.25 0 00-.354 0L15.061 6 18 8.94l1.263-1.263a.25.25 0 000-.354l-2.586-2.586z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};